import { render, staticRenderFns } from "./crashLayout.vue?vue&type=template&id=12004be0&"
import script from "./crashLayout.vue?vue&type=script&lang=js&"
export * from "./crashLayout.vue?vue&type=script&lang=js&"
import style0 from "./crashLayout.vue?vue&type=style&index=0&id=12004be0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports